import { db } from '../config/firebase';
import { collection, getDocs, doc, setDoc, deleteDoc, orderBy, query } from 'firebase/firestore';

export interface Shareholder {
  id: string;
  shareholderName: string;
  country: string;
  companyIndividual: 'Company' | 'Individual';
  shareholderSince: string;
  shares: number;
  hoasShares: number;
  entity: 'HOH' | 'HOAS';
}

const CAP_TABLE_COLLECTION = 'capTable';

export const getShareholders = async (): Promise<Shareholder[]> => {
  const q = query(collection(db, CAP_TABLE_COLLECTION), orderBy('shareholderSince', 'asc'));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(d => ({ id: d.id, ...d.data() } as Shareholder));
};

export const addShareholder = async (shareholder: Omit<Shareholder, 'id'>): Promise<Shareholder> => {
  const newId = doc(collection(db, CAP_TABLE_COLLECTION)).id;
  const newShareholder = { ...shareholder, id: newId };
  await setDoc(doc(db, CAP_TABLE_COLLECTION, newId), newShareholder);
  return newShareholder;
};

export const updateShareholder = async (shareholder: Shareholder): Promise<void> => {
  await setDoc(doc(db, CAP_TABLE_COLLECTION, shareholder.id), shareholder, { merge: true });
};

export const deleteShareholder = async (id: string): Promise<void> => {
  await deleteDoc(doc(db, CAP_TABLE_COLLECTION, id));
}; 